module.exports = __webpack_public_path__ + "img/hq.b4da5b8f.png";